import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { logButtonClick } from 'features/navigation/utils/analytics';

import { ClickEventComponentNames } from 'state/amplitude';
import { t } from 'state/intl/translations';

import { CloseButtonWrapper, PressableButton } from './styled';

interface IProductDetailClose {
  onDismiss: () => void;
  eventAttributes?: { [key: string]: string };
  color?: string;
}

export const ProductDetailClose: React.FC<IProductDetailClose> = ({
  onDismiss,
  eventAttributes = {},
  color,
}) => {
  const logEventAndDismiss = () => {
    logButtonClick({
      attributes: {
        ...eventAttributes,
        name: eventAttributes.name ?? '',
        component: ClickEventComponentNames.PRODUCT_DETAIL_CLOSE,
      },
    });

    onDismiss();
  };

  return (
    <CloseButtonWrapper>
      <PressableButton
        onPress={logEventAndDismiss}
        accessibilityRole="button"
        accessibilityLabel={t('close')}
      >
        <Icon variant="cancel" color={color} />
      </PressableButton>
    </CloseButtonWrapper>
  );
};
